export default __webpack_public_path__ + "static/media/reebok-marker.f2a83497.svg";